import React from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import $ from 'jquery';
import qs from 'qs';

import ForgotPassword from './ForgotPassword';
import ForgotUsername from './ForgotUsername';
import * as loginActions from '../../redux/login';
import logo from './../../svg/nc-logo-w.svg';
import './../Form.css';
import './Login.css';

require('bootstrap');

interface Props {
  loginActions?: any;
  error: boolean;
  clearError: any;
  login?: any;
  location: Location;
}

class Login extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.login = this.login.bind(this);
    this.state = { loginFailed: false };

    document.title = 'Login • Neoncoat Brands Tool';
  }

  login(form: any) {
    this.props.clearError();
    this.props.login(form, qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).redirect);
  }

  openForgotPassword() {
    $('#exampleModal').modal('show');
  }

  openForgotUsername() {
    $('#exampleModalU').modal('show');
  }

  render() {
    return (
      <div className="pdf-render">
        <div className="login-box">
          <div className="row logo-container">
            <img src={logo} alt="Neon Coat logo" />
          </div>
          {this.props.error ? (
            <div
              className="alert alert-danger login-error"
              role="alert"
              data-testid="login-error-message"
            >
              <p className="mb-0">The username or password you entered is incorrect.</p>
            </div>
          ) : null}
          <div className="form-wrapper">
            <Form
              onSubmit={this.login}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-label">Username</label>
                    <Field name="username" component="input" type="text" />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Password</label>
                    <Field name="password" component="input" type="password" />
                  </div>

                  <div className="form-group">
                    <div
                        className="submit-login"
                        onClick={() => handleSubmit()}
                        data-testid="login-button-test"
                    />
                  </div>
                </form>
              )}
            />
            <ForgotPassword />
            <ForgotUsername />
          </div>
          <div style={{ textAlign: 'center' }}>
            <div className="link-container">
              <span onClick={this.openForgotUsername} className="login-links" role="button">
                Forgot username?
              </span>
              <span onClick={this.openForgotPassword} className="login-links" role="button">
                Forgot password?
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state: any) => ({ error: state.login.loginError }), loginActions)(Login);
